import getImageUrl from '../../../../functions/getImageUrl'
import Button from '../../../general/Button'
import ImageWithFallback from '../../../general/ImageWithFallback'

const ImageDisplayAndDelete = ({field = 0, index = 0, image, imagePosition, imagePositionX, isDisabled, imageSize = false, onDeleteImage, imageType}) => {
    if(image) {
        const hasCustomSize = false !== imageSize
        let formatClass 
        let sizeQuery = ''

        if(hasCustomSize) {
            formatClass = 'item-custom-size'
        } else if(imageType === 'logo') {
            formatClass = 'item-logo-format'
        } else if(field && field.name && (field.name === 'movie.images.poster' || image.format === "portrait")) {
            formatClass = 'item-poster-format' // ToDo: should not be item-poster-format
        } else {
            formatClass = 'item-poster-format landscape-poster' // ToDo: should not be item-poster-format
        }

        const isPoster = !(imageType === 'backgrounds' || imageType === 'ambient')
        const {finalImageURl, imageUrl} = getImageUrl(image.url, false, isPoster, false, true)

        const positionStylingY = {
            top: imagePosition ? imagePosition + '%' : image.positionY ? image.positionY + '%' : image.position ? image.position + '%' : '0%'
        }
      
        const positionStylingX = {
            left: imagePositionX ? imagePositionX + '%' : image.positionX ? image.positionX + '%' : '50%'
        }

        const styleCustomWidth = hasCustomSize ? {
            width: parseFloat((imageSize.width / imageSize.relativeTo) * 100) + '%'
        } : {}

        const sizeStyling = hasCustomSize ? {
            paddingTop: parseFloat((imageSize.height / imageSize.width) * 100) + '%'
        } : {}
        

        return (
            <div className={"image-display " + formatClass}>
                <div className={formatClass} style={styleCustomWidth}>
                    {hasCustomSize ? (
                        // ToDo: Use in any case with size wrapper

                        <div className="item-size-wrapper" style={sizeStyling}>
                            <div className="item-crossed-wrapper">
                                {(finalImageURl || imageUrl) && (
                                    <ImageWithFallback src={finalImageURl} srcFallback={imageUrl} alt={image.alt || ''} className="item-image" style={{objectFit: 'contain'}} />
                                )}
                            </div>
                        </div>
                    ) : imageType === 'logo' ? (() => {
                        const logoUrls = getImageUrl(image.url, false, false, false, true, false, true)
                        return <ImageWithFallback src={logoUrls.finalImageURl} srcFallback={logoUrls.imageUrl} alt={image.alt || ''} className="item-logo-image" />
                    })() : (
                        <ImageWithFallback src={finalImageURl} srcFallback={imageUrl} alt={image.alt || ''} className="item-image" style={{objectFit: 'cover'}} />
                    )}

                    <div className="item-title-wrapper title-item-empty" />

                    {((image.positionY !== undefined && image.positionY !== null) || imagePosition) && imageType !== 'logo' && <div className="show-position-wrapper">
                        <div className="show-position" style={positionStylingY} />
                    </div>}

                    {((image.positionX !== undefined && image.positionX !== null) || imagePositionX) && imageType !== 'logo' && <div className="show-position-wrapper">
                        <div className="show-position x-axis" style={positionStylingX} />
                    </div>}
                    
                    <Button
                        className="button button-delete-item"
                        transId="remove_button"
                        onClick={() => onDeleteImage(index)}
                        hideText={true}
                        disabled={isDisabled}
                    />
                </div>
            </div>
        )
    } else {
        return ''
    }
}

export default ImageDisplayAndDelete